package com.wintermar.inspection.feature.util.inspection_status

import androidx.compose.ui.graphics.Color
import org.jetbrains.compose.resources.DrawableResource

data class InspectionStatusContentModel(
    val iconColor: Color? = null,
    val icon: DrawableResource? = null,
    val label: String,
    val labelColor: Color,
    val backgroundColor: Color = Color.Transparent,
    val borderColor: Color = Color.Transparent
)
